export const FLAGCDN_BASE_URL = "https://flagcdn.com";

export const VALID_FLAG_FORMATS = ["png", "webp", "svg"];

/** VAT country codes that differ from ISO 3166-1 alpha-2 for flagcdn.com */
export const VAT_COUNTRY_TO_FLAG_ISO = {
  EL: "gr",
  XI: "gb",
};

export function resolveFlagCountryCode(vatCountryCode) {
  if (!vatCountryCode) {
    return "";
  }

  const upper = String(vatCountryCode).trim().toUpperCase();
  const mapped = VAT_COUNTRY_TO_FLAG_ISO[upper];
  if (mapped) {
    return mapped.toLowerCase();
  }

  if (/^[A-Z]{2}$/.test(upper)) {
    return upper.toLowerCase();
  }

  return "";
}

/**
 * Builds a FlagCDN URL for a VAT / ISO country code.
 * @see https://flagcdn.com
 */
export function getFlagCdnUrl(vatCountryCode, size = "w20", format = "webp") {
  const isoCode = resolveFlagCountryCode(vatCountryCode);
  if (!isoCode) {
    return "";
  }

  const safeFormat = VALID_FLAG_FORMATS.includes(format) ? format : "webp";
  const safeSize = String(size || "w20");

  return `${FLAGCDN_BASE_URL}/${safeSize}/${isoCode}.${safeFormat}`;
}
